import { useEffect } from "react";
import FleetSection from "components/Sections/Fleet";
import { NextApiRequest } from "next";
import useStore, { Vehicle } from "store";

import API_URL from "../constants";

type Props = {
  vehicles: Vehicle[];
  widgetId: string;
}

export default function Fleet(props:Props) {
  const { vehicles, widgetId } = props;
  const { setVehicles } = useStore();

  useEffect(() => {
    setVehicles(vehicles);
  }, [setVehicles, vehicles]);

  return (
    <>
      <FleetSection widgetId={widgetId} />
    </>
  );
}

export async function getServerSideProps(context: NextApiRequest) {
  const { locale } = context.query;

  const response = await fetch(`${API_URL}/api/public/get-site-by-id`, {
    method: "POST",
    body: JSON.stringify({
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      domain: context?.req.headers.host,
      locale,
      page: "FLEET",
    }),
  });

  const {
    widgetId, company, seo, headCode = "", metaTags, scripts,
    vehicles, locale: siteLocale, currencySymbol,
  } = await response.json();

  return {
    props: {
      company,
      locale: siteLocale,
      seo,
      headCode,
      vehicles,
      widgetId,
      currencySymbol,
      metaTags,
      scripts,
    },
  };
}
